/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiAuthBarberLogin200, PostApiAuthBarberLogin400, PostApiAuthBarberLogin401, PostApiAuthBarberLogin409, PostApiAuthBarberLogin423, PostApiAuthBarberLoginMutationRequest, PostApiAuthBarberLoginMutationResponse } from "../entities/PostApiAuthBarberLogin";
import { modelsAuthBarberLoginInputSchema } from "./models/authBarberLoginInputSchema";
import { modelsAuthSessionOutputSchema } from "./models/authSessionOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiAuthBarberLogin200Schema = z.lazy(() => modelsAuthSessionOutputSchema) as unknown as z.ZodType<PostApiAuthBarberLogin200>

/**
 * @description Bad Request
 */
export const postApiAuthBarberLogin400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberLogin400>

/**
 * @description Unauthorized
 */
export const postApiAuthBarberLogin401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberLogin401>

/**
 * @description Conflict
 */
export const postApiAuthBarberLogin409Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberLogin409>

/**
 * @description Locked
 */
export const postApiAuthBarberLogin423Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberLogin423>

/**
 * @description Телефон и PIN-код
 */
export const postApiAuthBarberLoginMutationRequestSchema = z.lazy(() => modelsAuthBarberLoginInputSchema) as unknown as z.ZodType<PostApiAuthBarberLoginMutationRequest>

export const postApiAuthBarberLoginMutationResponseSchema = z.lazy(() => postApiAuthBarberLogin200Schema) as unknown as z.ZodType<PostApiAuthBarberLoginMutationResponse>